// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"48ef7d2b","486":"ae3c0962","552":"93a93cd9"}[chunkId] + ".chunk.css";
};